module.exports = __webpack_public_path__ + "img/logo-qualiopi.5fec5e5.png";